import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

export async function postUserLogin(email, password, { force = false } = {}) {
  try {
    const res = await fetch(`${BACKEND_URL}/user/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify({ email, password, force }),
    });

    const ct = res.headers.get("content-type") || "";
    const data = ct.includes("application/json")
      ? await res.json().catch(() => null)
      : null;

    if (!res.ok) {
      if (!data) return { success: false, message: `HTTP_${res.status}` };
      return {
        ...data,
        ...normalizeApiMessage(data, `HTTP_${res.status}`),
      };
    }

    if (!data) return null;
    return {
      ...data,
      ...normalizeApiMessage(data),
    };
  } catch (error) {
    console.error("postUserLogin request failed:", error);
    return {
      success: false,
      message: "Network error",
      messageKey: "api.common.networkError",
    };
  }
}
